import React from "react";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles({
  colorsConnect: {
    background:
      // top to bottom
      "linear-gradient(#FDE724, #79D151, #22A784,  #29788E, #404387, #440154)",
    marginBottom: "5px",
  },
});

export default function LegendCanopyCvr() {
  const classes = useStyles();

  return (
    <div>
      <div className="legend3">
        <Grid container>
          <Grid item xs={12}>
            <p align="center">Canopy Cover</p>
          </Grid>
          <Grid item xs={5} className={classes.colorsConnect}>
            <div></div>
          </Grid>
          <Grid item xs={7}>
            <div>
              <div>
                <span>- 100%</span>
              </div>
              <br></br>
              <div>
                <span>- 80%</span>
              </div>
              <br></br>
              <div>
                <span>- 60%</span>
              </div>
              <br></br>
              <div>
                <span>- 40%</span>
              </div>
              <br></br>
              <div>
                <span>- 20%</span>
              </div>
              <br></br>

              <div>
                <span>- 0</span>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
